document.querySelectorAll('.js-nav-trigger').forEach(trigger => {
    trigger.addEventListener('click', event => {
        event.preventDefault();

        trigger.classList.toggle('is-active');

        document.querySelectorAll('.js-nav').forEach(sib => sib.classList.toggle('is-active'));
        
        document.body.classList.toggle('has-open-nav');
    });
});
